<div class="reseller-page-wrapper page-shell">
  <mat-toolbar class="header">
    <span>{{ "reseller.title" | translate }}: {{ mainDomainsCount }}</span>
    <div class="header-buttons">
      <button
        mat-stroked-button
        type="button"
        (click)="loadData()"
        [disabled]="loading"
      >
        <mat-icon>refresh</mat-icon>
        {{ "cardOrders.refresh" | translate }}
      </button>
    </div>
  </mat-toolbar>

  <div class="reseller-content">
    <div
      class="table-container"
      [class.table-container--empty]="!loading && dataSource.data.length === 0"
      [class.table-container--loading]="loading"
    >
      <mat-table [dataSource]="dataSource" class="reseller-table mat-elevation-z0">
        <ng-container matColumnDef="expand">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let element">
            <button
              mat-icon-button
              type="button"
              (click)="toggleExpand(element.domain)"
              *ngIf="shouldShowExpandIcon(element)"
              [matTooltip]="
                isExpanded(element.domain)
                  ? ('reseller.collapse' | translate)
                  : ('reseller.expand' | translate)
              "
            >
              <mat-icon>{{
                isExpanded(element.domain) ? "expand_less" : "expand_more"
              }}</mat-icon>
            </button>
            <button
              mat-icon-button
              type="button"
              *ngIf="isSubdomain(element)"
              class="subdomain-indicator"
              disabled
            >
              <mat-icon>remove</mat-icon>
            </button>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef>{{
            "reseller.name" | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div
              class="name-wrapper"
              (click)="goToDomain(element.domain)"
              [matTooltip]="'reseller.goToDomain' | translate"
            >
              <mat-icon>open_in_browser</mat-icon>
              <img
                [src]="element.photoUrl || '/assets/img/favicon.png'"
                class="client-image"
                alt=""
              />
              <div class="domain-info">
                <span>{{ element.name || "-" }}</span>
                <code>{{ element.domain }}</code>
              </div>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="licenseCount">
          <mat-header-cell *matHeaderCellDef>{{
            "reseller.licenseCount" | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span class="license-count">{{ element.totalLicenseCount }}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div class="table-actions">
              <button
                type="button"
                class="action-btn action-btn--icon"
                *ngIf="!isSubdomain(element)"
                (click)="addClient(element)"
                [matTooltip]="'reseller.addClient' | translate"
                [attr.aria-label]="'reseller.addClient' | translate"
              >
                <mat-icon>add</mat-icon>
              </button>
              <button
                type="button"
                class="action-btn action-btn--icon"
                *ngIf="!isSubdomain(element)"
                (click)="attachDomain(element)"
                [matTooltip]="'reseller.attachDomain' | translate"
                [attr.aria-label]="'reseller.attachDomain' | translate"
              >
                <mat-icon>link</mat-icon>
              </button>
              <button
                type="button"
                class="action-btn action-btn--icon action-btn--danger"
                *ngIf="isSubdomain(element)"
                (click)="
                  detachDomain(
                    partners.get(element.parentDomain) || element,
                    element.domain
                  )
                "
                [matTooltip]="'reseller.detachDomain' | translate"
                [attr.aria-label]="'reseller.detachDomain' | translate"
              >
                <mat-icon>link_off</mat-icon>
              </button>
              <button
                type="button"
                class="action-btn action-btn--icon action-btn--danger"
                *ngIf="isSubdomain(element)"
                (click)="
                  removeClient(
                    partners.get(element.parentDomain) || element,
                    element.domain
                  )
                "
                [matTooltip]="'reseller.removeClient' | translate"
                [attr.aria-label]="'reseller.removeClient' | translate"
              >
                <mat-icon>delete_outline</mat-icon>
              </button>
            </div>
          </mat-cell>
        </ng-container>

        <mat-header-row
          *matHeaderRowDef="displayedColumns"
        ></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: displayedColumns"
          [class.subdomain]="row.parentDomain"
          [attr.data-domain]="row.domain"
        ></mat-row>
      </mat-table>

      <div class="loading-wrapper" *ngIf="loading">
        <app-loading></app-loading>
      </div>

      <div class="empty-state" *ngIf="!loading && dataSource.data.length === 0">
        <mat-icon class="empty-state__icon">store</mat-icon>
        <p>{{ "reseller.empty" | translate }}</p>
      </div>
    </div>
  </div>
</div>
